if (!customElements.get('custom-product-recommendations')) {
  class CustomProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('custom-product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.initInertSyncObservers();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }

    /**
     * Sets up MutationObservers on each recommendation item to sync the
     * `inert` attribute based on `aria-hidden` state. This ensures hidden
     * carousel items are properly marked as inert for screen readers.
     */
    initInertSyncObservers() {
      const items = this.querySelectorAll('[data-recommendation-id]');

      items.forEach((item) => {
        const syncAttributes = () => {
          if (item.getAttribute('aria-hidden') === 'true') {
            item.setAttribute('inert', '');
          } else {
            item.removeAttribute('inert');
          }
        };

        syncAttributes();

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
              syncAttributes();
            }
          });
        });

        observer.observe(item, { attributes: true });
      });
    }
  }

  customElements.define('custom-product-recommendations', CustomProductRecommendations);
}
